import { render, staticRenderFns } from "./CleaningFormService.vue?vue&type=template&id=0f35fb1c&scoped=true&"
import script from "./CleaningFormService.vue?vue&type=script&lang=js&"
export * from "./CleaningFormService.vue?vue&type=script&lang=js&"
import style0 from "./CleaningFormService.vue?vue&type=style&index=0&id=0f35fb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35fb1c",
  null
  
)

export default component.exports